import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { Button, Menu, MenuItem } from '@mui/material'
import { GridColumnIcon } from '@mui/x-data-grid-pro'
import { type FC, type MouseEvent, useState } from 'react'

export type ColumnTemplateId = 'pre-mba' | 'post-mba' | 'port-ops' | 'all'

const TEMPLATE_OPTIONS: Array<{ id: ColumnTemplateId; label: string }> = [
    { id: 'pre-mba', label: 'Pre-MBA' },
    { id: 'post-mba', label: 'Post-MBA' },
    { id: 'port-ops', label: 'Port Ops' },
    { id: 'all', label: 'All' },
]

interface ColumnTemplateDropdownProps {
    selectedTemplate: ColumnTemplateId
    onSelectTemplate: (template: ColumnTemplateId) => void
}

export const ColumnTemplateDropdown: FC<ColumnTemplateDropdownProps> = ({
    selectedTemplate,
    onSelectTemplate,
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const selectedLabel =
        TEMPLATE_OPTIONS.find((t) => t.id === selectedTemplate)?.label ??
        'Pre-MBA'

    return (
        <>
            <Button
                variant="text"
                size="small"
                onClick={handleClick}
                startIcon={<GridColumnIcon sx={{ fontSize: '1rem' }} />}
                endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />}
                sx={{
                    ml: 2,
                    textTransform: 'none',
                    fontSize: '0.75rem',
                }}
            >
                Column Template: {selectedLabel}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    dense: true,
                }}
            >
                {TEMPLATE_OPTIONS.map((template) => (
                    <MenuItem
                        key={template.id}
                        selected={selectedTemplate === template.id}
                        onClick={() => {
                            onSelectTemplate(template.id)
                            handleClose()
                        }}
                        sx={{ fontSize: '0.75rem' }}
                    >
                        {template.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}
